"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productUtils = void 0;
const __1 = require("..");
const getDescription = (product, language) => {
    let description = product === null || product === void 0 ? void 0 : product.description_en;
    if (language === "fr")
        description = product === null || product === void 0 ? void 0 : product.description_fr;
    if (language === "de")
        description = product === null || product === void 0 ? void 0 : product.description_de;
    if (language === "us")
        description = product === null || product === void 0 ? void 0 : product.description_us;
    if (language === "nl")
        description = product === null || product === void 0 ? void 0 : product.description_nl;
    return description || (product === null || product === void 0 ? void 0 : product.description_en) || "";
};
const guessColors = ({ code, splitNumber = "0", }) => {
    var _a, _b, _c;
    const beforeSlashPart = code === null || code === void 0 ? void 0 : code.split("/")[0];
    const afterSlashPart = code === null || code === void 0 ? void 0 : code.split("/")[1];
    let affix = (_a = beforeSlashPart === null || beforeSlashPart === void 0 ? void 0 : beforeSlashPart.split(splitNumber)) === null || _a === void 0 ? void 0 : _a.pop();
    if (afterSlashPart) {
        affix += "/" + afterSlashPart;
    }
    let lastNumber = undefined;
    if (!afterSlashPart) {
        const numbers = code === null || code === void 0 ? void 0 : code.replace(/\D/g, "%").split("%").reduce((acc, curr) => {
            if (curr)
                acc.push(curr);
            return acc;
        }, []);
        lastNumber = numbers === null || numbers === void 0 ? void 0 : numbers.pop();
        if (lastNumber) {
            affix = (_b = code === null || code === void 0 ? void 0 : code.split(lastNumber)) === null || _b === void 0 ? void 0 : _b.pop();
        }
    }
    else {
        const numbers = beforeSlashPart === null || beforeSlashPart === void 0 ? void 0 : beforeSlashPart.replace(/\D/g, "%").split("%").reduce((acc, curr) => {
            if (curr)
                acc.push(curr);
            return acc;
        }, []);
        lastNumber = numbers === null || numbers === void 0 ? void 0 : numbers.pop();
        if (lastNumber) {
            affix = (_c = code === null || code === void 0 ? void 0 : code.split(lastNumber)) === null || _c === void 0 ? void 0 : _c.pop();
        }
    }
    affix = (affix || "").toUpperCase();
    if (affix === code) {
        const lastChar = affix.substr(affix.length - 1, 1);
        if (["G", "Z", "W", "R", "WW", "NW", "C", "V"].includes(lastChar)) {
            affix = lastChar;
        }
    }
    let color_en = "";
    let color_us = "";
    let color_nl = "";
    let color_de = "";
    let color_fr = "";
    if (affix === "G") {
        color_en = "Grey";
        color_us = "Grey";
        color_nl = "Grijs";
        color_de = "Grau";
        color_fr = "Gris";
    }
    if (affix === "R") {
        color_en = "Red";
        color_us = "Red";
        color_nl = "Rood";
        color_de = "Rot";
        color_fr = "Rouge";
    }
    if (affix === "Z") {
        color_en = "Black";
        color_us = "Black";
        color_nl = "Zwart";
        color_de = "Schwarz";
        color_fr = "Noir";
    }
    if (affix === "B") {
        color_en = "Blue";
        color_us = "Blue";
        color_nl = "Blauw";
        color_de = "Blau";
        color_fr = "Bleu";
    }
    if (affix === "W") {
        color_en = "White";
        color_us = "White";
        color_nl = "Wit";
        color_de = "Weiss";
        color_fr = "Blanc";
    }
    if (affix === "WW") {
        color_en = "Extra White";
        color_us = "Extra White";
        color_nl = "Extra Wit";
        color_de = "Extra Weiss";
        color_fr = "Extra Blanc";
    }
    if (affix === "NW") {
        color_en = "Nordic White";
        color_us = "Nordic White";
        color_nl = "Nordic Wit";
        color_de = "Nordic Weiss";
        color_fr = "Nordic Blanc";
    }
    if (affix === "C") {
        color_en = "Cork";
        color_us = "Cork";
        color_nl = "Cork";
        color_de = "Cork";
        color_fr = "Cork";
    }
    if (affix === "V") {
        color_en = "Green";
        color_us = "Green";
        color_nl = "Groen";
        color_de = "Grün";
        color_fr = "Vert";
    }
    return {
        color_en: color_en || affix,
        color_us: color_us || affix,
        color_nl: color_nl || affix,
        color_de: color_de || affix,
        color_fr: color_fr || affix,
    };
};
const guessSerieName = ({ code }) => {
    const beforeNumberPart = code === null || code === void 0 ? void 0 : code.replace(/[0-9]/g, "%").split("%")[0];
    return beforeNumberPart;
};
const getPrice = ({ product, currency, }) => {
    if (currency === __1.ECurrency.euro)
        return (product === null || product === void 0 ? void 0 : product.price_euro) || 0;
    if (currency === __1.ECurrency.usdollar)
        return (product === null || product === void 0 ? void 0 : product.price_usdollar) || 0;
    return 0;
};
const getStockAmounts = ({ product, production, }) => {
    const productProduction = production.filter((_) => _.productId === product.id);
    const modeledProduction = productProduction.filter((_) => _.status === __1.EProductionStatus.modeled);
    const bakedProduction = productProduction.filter((_) => _.status === __1.EProductionStatus.baked);
    const unlockedModeledAmount = modeledProduction.filter((_) => !_.lockedAt).length;
    const unlockedBakedAmount = bakedProduction.filter((_) => !_.lockedAt).length;
    const lockedModeledAmount = modeledProduction.filter((_) => _.lockedAt).length;
    const lockedBakedAmount = bakedProduction.filter((_) => _.lockedAt).length;
    return {
        unlockedModeledAmount,
        unlockedBakedAmount,
        lockedModeledAmount,
        lockedBakedAmount,
    };
};
exports.productUtils = {
    getDescription,
    guessColors,
    guessSerieName,
    getPrice,
    getStockAmounts,
};
//# sourceMappingURL=productUtils.js.map